// extracted by mini-css-extract-plugin
export default {"container":"ocagHZKU1fhYx6rOmgZGc"};